import {
  SquaresFour,
  FileText,
  Coins,
  ClipboardText,
  ChartBar,
  Folders,
  ArrowsClockwise,
  UploadSimple,
  Warning,
  UsersThree,
  Users,
  CreditCard,
  Megaphone,
  ShieldCheck,
} from "@phosphor-icons/react";

// Navigation entries per role. `to` is a route path.
const COMMON = { dashboard: { to: "/dashboard", label: "Dashboard", icon: SquaresFour } };
const ESCALATIONS = { to: "/escalations", label: "Escalations", icon: Warning };
const GRANTEES = { to: "/grantees", label: "Grantees", icon: UsersThree };
const TEAM = { to: "/team", label: "Team", icon: Users };
const BILLING = { to: "/billing", label: "Billing", icon: CreditCard };
export const WHATS_NEW = { to: "/whats-new", label: "What's New", icon: Megaphone };

export const NAV_BY_ROLE = {
  contract_administrator: [
    COMMON.dashboard,
    { to: "/contracts", label: "Contracts", icon: FileText },
    { to: "/grants", label: "Grants", icon: Coins },
    ESCALATIONS,
    GRANTEES,
    { to: "/documents", label: "Documents", icon: Folders },
    { to: "/import", label: "Import", icon: UploadSimple },
    { to: "/reports", label: "Reporting Center", icon: ChartBar },
  ],
  grant_manager: [
    COMMON.dashboard,
    { to: "/grants", label: "Grants", icon: Coins },
    { to: "/queue", label: "Review Queue", icon: ClipboardText },
    { to: "/contracts", label: "Linked Contracts", icon: FileText },
    GRANTEES,
    { to: "/documents", label: "Documents", icon: Folders },
    { to: "/import", label: "Import", icon: UploadSimple },
    { to: "/reports", label: "Reporting Center", icon: ChartBar },
  ],
  contract_specialist: [
    COMMON.dashboard,
    { to: "/queue", label: "Pending Reviews", icon: ClipboardText },
    { to: "/contracts", label: "Contracts", icon: FileText },
    { to: "/documents", label: "Document Review", icon: Folders },
    { to: "/reports", label: "Reporting Center", icon: ChartBar },
  ],
  legal_reviewer: [
    COMMON.dashboard,
    { to: "/queue", label: "Final Review Queue", icon: ClipboardText },
    { to: "/contracts", label: "Contracts", icon: FileText },
    { to: "/reports", label: "Reporting Center", icon: ChartBar },
  ],
  leadership: [
    COMMON.dashboard,
    { to: "/contracts", label: "Contracts", icon: FileText },
    { to: "/grants", label: "Grants", icon: Coins },
    ESCALATIONS,
    { to: "/reports", label: "Reporting Center", icon: ChartBar },
  ],
  admin: [
    COMMON.dashboard,
    { to: "/contracts", label: "Contracts", icon: FileText },
    { to: "/grants", label: "Grants", icon: Coins },
    { to: "/queue", label: "Review Queue", icon: ClipboardText },
    ESCALATIONS,
    GRANTEES,
    { to: "/documents", label: "Documents", icon: Folders },
    { to: "/import", label: "Import", icon: UploadSimple },
    { to: "/reports", label: "Reporting Center", icon: ChartBar },
    TEAM,
    { to: "/audit", label: "Audit Log", icon: ShieldCheck },
    BILLING,
  ],
};

export const STAGE_META = {
  intake: { label: "Intake / Drafting", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  grant_manager_review: { label: "Grant Manager Review", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  contract_specialist_review: { label: "Specialist Review", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  ready_for_legal: { label: "Ready for Legal", cls: "bg-violet-50 text-violet-800 border-violet-300" },
  executed: { label: "Executed", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  closed: { label: "Closed", cls: "bg-slate-200 text-slate-700 border-slate-400" },
};
